__webpack_require__.p = "https://dev-cdn.journexx.com/jcw/0.0.2-88ca4b14/";